import React, { Component } from "react";

// Images
import car1 from "../../images/why-choose/car-1.png";
import car2 from "../../images/why-choose/car-2.png";
import car3 from "../../images/why-choose/car-3.png";
import car4 from "../../images/why-choose/car-4.png";
import car5 from "../../images/why-choose/car-5.png";
import car6 from "../../images/why-choose/car-6.png";

class VehicleServicesSection extends Component {
  render() {
    return (
      <>
        <section className="section-area section-sp1 bg-white">
          <div className="container">
            <div className="row mb-20">
              <div className="heading-bx mb-4 pr-lg-5">
                <h6 className="title-ext m-b0 text-primary">TJÄNSTER VI ERBJUDER</h6>
                <h4 className="title">EXEMPEL PÅ BILMÄRKEN VI ARBETAR MED</h4>
                <p className="partner-text">
                  Vi hjälper dig att hålla din bil i toppskick. Våra tjänster inkluderar lackering, bilskadebesiktning,
                  service, tvätt och rekond. Vi har erfarenhet av många bilmärken, inklusive de som visas här, men vi
                  tar också hand om andra märken. Du kan alltid lita på oss för noggrann och professionell service.
                </p>
              </div>
            </div>
            <div className="row mb-30 d-flex justify-content-center">
              <div className="col-lg-2 col-md-4 col-sm-6 text-center mb-3">
                <img src={car1} alt="Brand 1" className="carlogo-img" />
              </div>
              <div className="col-lg-2 col-md-4 col-sm-6 text-center mb-3">
                <img src={car2} alt="Brand 2" className="carlogo-img" />
              </div>
              <div className="col-lg-2 col-md-4 col-sm-6 text-center mb-3">
                <img src={car3} alt="Brand 3" className="carlogo-img" />
              </div>
              <div className="col-lg-2 col-md-4 col-sm-6 text-center mb-3">
                <img src={car4} alt="Brand 4" className="carlogo-img" />
              </div>
              <div className="col-lg-2 col-md-4 col-sm-6 text-center mb-3">
                <img src={car5} alt="Brand 5" className="carlogo-img" />
              </div>
              <div className="col-lg-2 col-md-4 col-sm-6 text-center mb-3">
                <img src={car6} alt="Brand 6" className="carlogo-img" />
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default VehicleServicesSection;
